/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IVinhusetSearch contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export interface IVinhusetSearchConfig extends Msdyn365.IModuleConfig {
    suggestionTypeCriterion?: ISuggestionTypeCriterionData[];
    topResultsCount?: number;
    imageSettings?: Msdyn365.IImageSettings;
    disableSubmitSearch?: boolean;
    searchplaceholderText?: string;
    shouldShowFullCategoryPath?: boolean;
    noSearchResultImage?: Msdyn365.IImageData;
    className?: string;
    clientRender?: boolean;
}

export interface IVinhusetSearchResources {
    searchtext: string;
    searchLabelArialLabel: string;
    cancelBtnAriaLabel: string;
    searchBtnAriaLabel: string;
    submitBtnAriaLabel: string;
    autoSuggestFoundMessage: string;
    noAutoSuggestionMessage: string;
    productSuggestionHeading: string;
    categorySuggestionHeading: string;
    autoSuggestResultLoadingMessage: string;
    freePriceText: string;
    searchSuggestionHeading: string;
    keywordsHeading: string;
    noResultText: string;
    noResultContentHeadingText: string;
    noResultContentParagraphText: string;
    clearSearchButtonText: string;
    emptyMobileSearchTextHeading: string;
    emptyMobileSearchText: string;
    categorySuggestionProductCount: string;
    categorySuggestionProductCountPlural: string;
    categorySuggestionJoinerText: string;
    inCartTooltipText: string;
    addToCartButtonText: string;
    productsAddedToCart: string;
    productsRemovedFromCart: string;
    productsUpdatedInCart: string;
    toastErrorHeader: string;
    toastGoToCart: string;
    toastNoAccessToProduct: string;
    pricePerText: string;
    modalCloseButtonText: string;
    noCameraDevicesFoundText: string;
    errorGettingDevicesText: string;
    chooseCameraText: string;
    changeCameraText: string;
    expiredText: string;
}

export const enum SuggestionTypeCriterionSuggestionType {
    product = 'product',
    keyword = 'keyword',
    scopedCategory = 'scopedCategory'
}

export interface ISuggestionTypeCriterionData {
    SuggestionType?: SuggestionTypeCriterionSuggestionType;
}

export interface IVinhusetSearchProps<T> extends Msdyn365.IModule<T> {
    resources: IVinhusetSearchResources;
    config: IVinhusetSearchConfig;
}
